/**
 * DeviceSelectionCard — Device selection with cascading dropdowns + action buttons.
 *
 * Server → Device Type (Area/Resident) → Entity → Device
 * Actions: Create Alarm, Rounds (AIO only), Check-In (AIO only), Simulate Careflow
 *
 * All state owned by parent DemoPage. Zero document.getElementById.
 */

const DeviceSelectionCard = ({
    // Server
    serverOptions,
    server,
    onServerChange,
    // Type
    dataType,
    onDataTypeChange,
    // Entity
    entityOptions,
    entityIndex,
    onEntityChange,
    entityLabel,
    // Device
    deviceOptions,
    deviceIndex,
    onDeviceChange,
    // Actions
    canSubmit,
    isAioDevice,
    loadingAlarm,
    loadingRounds,
    loadingCheckin,
    onCreateAlarm,
    onRounds,
    onCheckin,
    onSimulate,
    loadingSimulate,
}) => {
    return (
        <div className="dm-card">
            <h3 className="dm-card__header">Device Selection</h3>
            <div className="dm-card__body">
                {/* Server */}
                <div>
                    <label htmlFor="dm-server" className="dm-field__label">Server</label>
                    <select
                        id="dm-server"
                        className="dm-field__select"
                        value={server}
                        onChange={(e) => onServerChange(e.target.value)}
                    >
                        {serverOptions.length === 0 ? (
                            <option value="">No available servers</option>
                        ) : serverOptions.map((s) => (
                            <option key={s.value} value={s.value}>{s.label}</option>
                        ))}
                    </select>
                </div>

                {/* Device Type */}
                <div>
                    <label htmlFor="dm-datatype" className="dm-field__label">Device Type</label>
                    <select
                        id="dm-datatype"
                        className="dm-field__select"
                        value={dataType}
                        onChange={(e) => onDataTypeChange(e.target.value)}
                    >
                        <option value="" disabled>-- Select --</option>
                        <option value="area">Area</option>
                        <option value="resident">Resident</option>
                    </select>
                </div>

                {/* Entity (Resident or Area) */}
                <div>
                    <label htmlFor="dm-entity" className="dm-field__label">{entityLabel || 'Entity'}</label>
                    <select
                        id="dm-entity"
                        className="dm-field__select"
                        value={entityIndex}
                        onChange={(e) => onEntityChange(e.target.value)}
                        disabled={!dataType}
                    >
                        <option value="" disabled>-- Select --</option>
                        {entityOptions.map((opt) => (
                            <option key={opt.value} value={opt.value} disabled={opt.disabled}>
                                {opt.label}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Device */}
                <div>
                    <label htmlFor="dm-device" className="dm-field__label">Device</label>
                    <select
                        id="dm-device"
                        className="dm-field__select"
                        value={deviceIndex}
                        onChange={(e) => onDeviceChange(e.target.value)}
                        disabled={!entityIndex}
                    >
                        <option value="" disabled>-- Select --</option>
                        {deviceOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                    </select>
                </div>

                {/* Action Buttons */}
                <div className="dm-actions">
                    <button
                        className="dm-btn--danger"
                        onClick={onCreateAlarm}
                        disabled={!canSubmit || loadingAlarm}
                    >
                        {loadingAlarm ? <><span className="dm-spinner" />Creating...</> : 'Create Alarm'}
                    </button>

                    {isAioDevice ? (
                        <>
                            <button
                                className="rp-btn rp-btn--primary"
                                onClick={onRounds}
                                disabled={!canSubmit || loadingRounds}
                            >
                                {loadingRounds ? <><span className="dm-spinner" />Creating...</> : 'Rounds'}
                            </button>
                            <button
                                className="rp-btn rp-btn--primary"
                                onClick={onCheckin}
                                disabled={!canSubmit || loadingCheckin}
                            >
                                {loadingCheckin ? <><span className="dm-spinner" />Creating...</> : 'Check-In'}
                            </button>
                        </>
                    ) : null}

                    <button
                        className="rp-btn rp-btn--primary"
                        onClick={onSimulate}
                        disabled={!canSubmit || loadingSimulate}
                    >
                        {loadingSimulate ? <><span className="dm-spinner" />Calculating...</> : 'Simulate Careflow'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeviceSelectionCard;
